import {Tooltip} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import React from "react";
import request from "../../../../Services/API/Requests";
import {toJson} from "./transformStringToJson";

const CreateItemsFromClipboard = ({insertItems}) => {
    async function insert() {
        try {
            const clipboardValue = await navigator.clipboard.readText();
            const schema = await request({
                url: "/schema/read",
                data: {
                    id: 'schemaField'
                }
            })
            const res = toJson(clipboardValue, 3, schema);
            insertItems(res)
        } catch (e) {
            console.log(e)
        }

    }

    return (
        <div style={{textAlign: 'center'}}>
            <Tooltip title={'Insert items from clipboard'}>
                <IconButton style={{padding: 5}} size={"small"}
                            onClick={insert}
                >
                    <Icon fontSize={"small"}>
                        file_copy
                    </Icon>
                </IconButton>
            </Tooltip>
        </div>
    )
}

export default CreateItemsFromClipboard